/* Account navigation and visitor language choices share the plain header. */
(() => {
  const menu = document.querySelector('[data-account-menu]');
  if (!menu) return;
  const button = menu.querySelector('[data-account-toggle]');
  const panel = menu.querySelector('[data-account-panel]');
  const items = () => [...panel.querySelectorAll('a, button[name="language_code"]')].filter(item => item.getClientRects().length);
  // Reduced motion gives the calm version on every page.
  const html = document.documentElement, calm = matchMedia('(prefers-reduced-motion: reduce)');
  const setCalm = () => html.classList.toggle('calm', calm.matches);
  setCalm(); calm.addEventListener?.('change', setCalm);
  [...panel.children].forEach((item, i) => item.style.setProperty('--i', i));
  let fade;
  const close = (restore = false) => {
    const wasOpen = !panel.hidden;
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    if (wasOpen && panel.classList.contains('am') && !html.classList.contains('calm')) {
      panel.classList.remove('am-out'); void panel.offsetWidth; panel.classList.add('am-out');
      clearTimeout(fade); fade = setTimeout(() => panel.classList.remove('am-out'), 180);
    }
    if (restore) button.focus();
  };
  const open = (last = false) => {
    clearTimeout(fade); panel.classList.remove('am-out');
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    const links = items();
    links[last ? links.length - 1 : 0]?.focus();
  };
  button.addEventListener('click', () => panel.hidden ? open() : close());
  button.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); open(event.key === 'ArrowUp');
    }
  });
  panel.addEventListener('keydown', event => {
    const links = items();
    if (!links.length) return;
    const index = links.indexOf(document.activeElement);
    let next;
    if (event.key === 'ArrowDown') next = (index + 1) % links.length;
    if (event.key === 'ArrowUp') next = (index - 1 + links.length) % links.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = links.length - 1;
    if (next != null) { event.preventDefault(); links[next].focus(); }
  });
  panel.addEventListener('click', event => { if (event.target.closest('a')) close(); });
  menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) close(); });
  document.addEventListener('click', event => { if (!menu.contains(event.target)) close(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
  });
  for (const form of document.querySelectorAll('[data-menu-languages] form')) {
    form.addEventListener('submit', () => {
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    });
  }
})();

// One-time offer of the visitor's own language on English pages (QA 25 Oct item 1). Never switches by itself.
(() => {
  if ((document.documentElement.lang || 'en') !== 'en') return;
  const key = 'cs-language-offer';
  try { if (localStorage.getItem(key)) return; } catch { return; }
  const offers = {
    es: ['es', '¿Ver CollabSeason en español?', 'Sí', 'No, gracias'],
    pt: ['pt', 'Ver o CollabSeason em português?', 'Sim', 'Não, obrigado'],
    fr: ['fr', 'Voir CollabSeason en français ?', 'Oui', 'Non merci'],
    de: ['de', 'CollabSeason auf Deutsch ansehen?', 'Ja', 'Nein, danke'],
    it: ['it', 'Vedere CollabSeason in italiano?', 'Sì', 'No, grazie'],
    pl: ['pl', 'Wyświetlić CollabSeason po polsku?', 'Tak', 'Nie, dziękuję'],
    ar: ['ar', 'عرض CollabSeason بالعربية؟', 'نعم', 'لا، شكرًا']
  };
  const wanted = (navigator.languages || [navigator.language || '']).map(l => String(l).slice(0, 2).toLowerCase());
  const first = wanted.find(l => l === 'en' || offers[l]);
  if (!first || first === 'en') return;
  const [prefix, question, yes, no] = offers[first];
  const box = document.createElement('div');
  box.className = 'cs-language-offer';
  box.setAttribute('role', 'region');
  box.setAttribute('aria-label', question);
  box.lang = first;
  if (first === 'ar') box.dir = 'rtl';
  const text = document.createElement('p'); text.textContent = question;
  const go = document.createElement('a'); go.className = 'cs-language-offer-yes'; go.textContent = yes;
  go.href = '/' + prefix + (location.pathname === '/' ? '' : location.pathname) + location.search + location.hash;
  const stay = document.createElement('button'); stay.type = 'button'; stay.className = 'cs-language-offer-no'; stay.textContent = no;
  const remember = value => { try { localStorage.setItem(key, value); } catch {} };
  go.addEventListener('click', () => remember('yes'));
  stay.addEventListener('click', () => { remember('no'); box.remove(); });
  const actions = document.createElement('div'); actions.append(go, stay);
  box.append(text, actions);
  document.body.append(box);
})();
